const initSwiperOptions = (slidesPerView, breakpoints, pagination, delay) => {
    const swiperOption = {
        slidesPerView: slidesPerView,
        loop: true,
        spaceBetween: 40,
        autoplay: {
            delay: delay || 5000,
            disableOnInteraction: false
        },
        navigation:  {
            nextEl: ".landing-slider-button-next",
            prevEl: ".landing-slider-button-prev"
        },
        pagination: pagination || {},
        breakpoints: breakpoints ? 
        {
            1400: {
                slidesPerView: 3,
                spaceBetween: 10
            },
            992: {
                slidesPerView: 2,
                spaceBetween: 30
            },
            768: {
                slidesPerView: 1,
                spaceBetween: 30
            }
        }: null
    }
    return {
        swiperOption
    }
}

export default initSwiperOptions